module.exports = __webpack_public_path__ + "img/kankou_20.a57d3dd4.jpg";